<template>
<div v-if="dataError == false" class="container">
    <div id="shipmentTrackingContents" class="shipment_data" >
      <img v-if="labelImage" class="logo" loading="lazy" :src="labelImage" alt="LREX">
      <img v-if="(labelImage == '') && (showShipmentData)" class="logo" src="../assets/LREXHeaderLogo.jpg" alt="LREX" style="width: 100px; margin-left: 5px !important;">
      <div v-if="showShipmentData">
        <h3 class="tracking-header">Tracking #: {{LRexAPIData.shipmentHistory[0].shipmentid}}</h3>
        <div class="shipment-info-container">
                <div class="shipment-info-container-inner">
                  <h3>Ship By</h3>
                  <p>{{LRexAPIData.deliveryPickup.address.companyName}}</p>
                  <p>{{LRexAPIData.deliveryPickup.address.address1}}</p>
                  <p>{{LRexAPIData.deliveryPickup.address.address2}}</p>
                  <p>{{LRexAPIData.deliveryPickup.address.city}}, {{LRexAPIData.deliveryPickup.address.state}}, {{LRexAPIData.deliveryPickup.address.zipCode}} </p>
                </div>

                <div class="shipment-info-container-inner">
                  <h3>Ship To</h3>
                  <p>{{LRexAPIData.serviceAddress.address.companyName}}</p>
                  <p>{{LRexAPIData.serviceAddress.address.address1}}</p>
                  <p>{{LRexAPIData.serviceAddress.address.address2}}</p>
                  <p>{{LRexAPIData.serviceAddress.address.city}}, {{LRexAPIData.serviceAddress.address.state}}, {{LRexAPIData.serviceAddress.address.zipCode}} </p>

                  <div class="additional-information" @click="ShowShipmentInformation()">
                    <p>Additional Information</p>
                    <i v-if="downArrow" class="down-arrow"></i>
                    <i v-if="upArrow" class="up-arrow"></i>
                  </div>
                  
                  <div v-show="showAdditionalInformation" v-for="items in LRexAPIData.product" v-bind:key="items" class="shipment-information">
                    <div class="shipment-information-inner">
                      <p>{{items.description}}</p>
                    </div>
                  </div>
                </div>
            </div>
      </div>

        <div class="input-zip-container" v-if="toggleEnterZip && !loading">
          <p>Want more shipment information?</p>
          <div class="input-zip-inner">
            
            <form @submit.prevent="TrackShipmentLRexAPI">
              <div class="zip-form-input">
                  <input type="text" placeholder="Enter ZipCode" v-model="posts.ZipCode">
              </div>
            </form>
            <button class="main-button-blue-white" @click="TrackShipmentLRexAPI">Search</button>
          </div>
        </div>

      <div v-if="showShipmentHistoryData">
          <h3>Package History</h3>
          <div class="history-container" v-for="(items, index) in LRexAPIDataHistory" v-bind:key="items">
            <div class="check-mark-container">
              <div class="check-mark" :class="{active:index==0, activeLast:index==LRexAPIDataHistory.length - 1}">
                <div class="check-mark-item"><img src="../assets/FinalImages/checkMark.png" alt=""></div>
              </div>
            </div>
            <div class="inner-history-container">
              <div class="history-description-container">
                <p class="history-description">{{LRexAPIDataHistory[index].description}}</p>
                <p class="history-process-date">{{LRexAPIDataHistory[index].processedDate}}</p>
              </div>
              
              <div v-if="LRexAPIDataHistory[index].description != 'Scanned out to partner network'">
                <p>{{LRexAPIDataHistory[index].notes}}</p>
              </div>
              
              <div >
                <div class="proof-delivery-container">
                  <button v-if="LRexAPIDataHistory[index].imageURL" @click="GetDeliveryImages(LRexAPIDataHistory[index].imageURL, index)" class="main-button-blue-white">Show Image</button>
                </div>
                <div v-if="(showOverLay) && (indexImageURL == index)" class="overlay-container">
                  <div class="overlay">
                    <div>
                      <button @click="()=>{this.showOverLay = false}">Close Image</button>
                      <a :href="linkImageURL" target="_blank">Open in new window</a>
                    </div>
                    
                    <div v-if="loadingImage">
                      <LoadingData :headerMessage="headerMessage"/>
                    </div>
                    <iframe class="proof-delivery-image" id="proof-delivery-iframe" :src="linkImageURL" alt="Delivery Image" frameborder="0"></iframe>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
        <button v-if="(LRexAPIData || LRexAPIDataHistory) && !loading" class="main-button-green-black" @click.prevent="PrintShipmentPage()">Print this page</button>
      </div>  
</div>

<div v-if="dataError" class="shipmentError">
  <div class="error-inner">
    <div>
      <img src="../assets/FinalImages/confusedLREXDino.png" alt="">
    </div>
    <div>
        <p>Shipment Data Unavailable.</p>
    </div>
  </div>
    
</div>

<div v-if="loading">
  <LoadingData :headerMessage="headerMessage"/>
</div>

<AlertUser v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/> 

</template>

<script>
import LoadingData from '../components/Popups/LoadingData.vue';
import AlertUser from '../components/Popups/AlertUser.vue';
import { Amplify, API } from 'aws-amplify';
import awsconfig from '../aws-exports';

export default {
    components:{
        LoadingData,
        AlertUser
    },
    watch:{
      'linkImageURL': function(newvalue,oldvalue){
        console.log(newvalue)
        console.log(oldvalue)
      }
    },
    data(){
        return{
            shipmentID: this.$route.params.shipId,
            shipmentZip: this.$route.params.shipZip,
            posts:{
              shipmentId: this.$route.params.shipId,
              ZipCode: this.$route.params.shipZip,
              IncludeImageURL: true
            },
            labelImage: '',
            linkImageURL: '',
            indexImageURL: '',
            showShipmentData: false,
            loading: false,
            headerMessage: "Loading Shipment Data",
            toggleAlertBox: false,
            alertMessage: "Invalid Zip Code",
            showAdditionalInformation: false,
            downArrow: true,
            upArrow: false,
            toggleEnterZip: true,
            LRexAPIData: [],
            showOverLay: false,
            loadingImage: false,
            dataError: false
        }
    },
    methods: {
      ShowShipmentInformation(){
        this.showAdditionalInformation = !this.showAdditionalInformation;
        this.downArrow = !this.downArrow;
        this.upArrow = !this.upArrow;
      },
      PrintShipmentPage(){
        var divContents = document.getElementById("shipmentTrackingContents").innerHTML;

        this.LRexAPIDataHistory.forEach(element => {
            if (element.imageURL) {
                var iframeHTML = `<iframe class="proof-delivery-image" src="${element.imageURL}" allowfullscreen frameborder="0"></iframe>`;
                divContents = divContents + iframeHTML;
            }
        });

        var a = window.open('LREX', 'LREX', 'height=1000, width=1000');
        a.document.write('<html>');
        a.document.write('<head>'
          + '<title>LREX Shipment Information</title>'
          +'<style> '
          + 'img{width: 150px;}'
          + 'body{font-family: sans-serif; font-size: 16px;}'
          + '.shipment-information-inner p{margin-top: 0 !important; margin-bottom: 0 !important; }'
          + '.shipment-information{display: flex !important; padding: 0 !important;}'
          + '.shipment-information p{margin-right: 5px; padding-right: 5px; border-right: 2px solid black;}'
          + '.additional-information{display: none;}'
          + '.input-zip-container{display: none;}'
          + '.proof-delivery-image{width: 100%; height: 100%;}' 
          + '.inner-history-container{border: 1px solid #b3b3b3;border-radius: 15px;padding: 15px;margin: 15px;margin-left: 12.5%; width: 50%;}'
          + '.check-mark.active{display: none;}'
          + '.check-mark.activeLast{display: none;}'
          + '.check-mark{display: none;}'
          + '.check-mark-item{display: none;}'
          + '.check-mark-item img{ display: none;}'
          + '.check-mark-container{display: none;}'
          + '.history-description{font-weight: bold;}'
          + '.history-description-container{display: flex;flex-direction: row;align-items: center;justify-content: space-between;}'
          + '.history-process-date{background: #f0f0f0;color: #858585;border-radius: 2.5px;padding: 2px;}'
          + '.history-container{position: relative;display: flex;justify-content: flex-start;align-items: center;}'
          + 'h3{border-bottom:2px solid black}'
          + 'button,.proofDelivery,.locationDelivery{display: none;}'
          + 'th,td{border: 1px solid black;}'
          + 'th{background-color: #33f18a}' 
          + 'table{width: 70%;}'
          + '</style>'
          + '</head>');
        a.document.write('<body>');
        a.document.write(divContents);
        a.document.write('</body></html>');

        setTimeout(function () {
          a.document.close();
          a.focus();
          a.print();
          a.close(); 
        }, 2000);
      },
      async TrackShipmentLRexAPI(){
        let getShipmnetHistoryInput = {
          shipmentID: "",
          ZipCode: this.posts.ZipCode
        }
        if(this.posts.shipmentId.length > 0){
          getShipmnetHistoryInput.shipmentID = this.posts.shipmentId;
        }else{
          this.LRexAPIData = []
          return;
        }
        
        this.loading = true;
        let graphqlQuery = `mutation MyMutation {
          getShipmentHistoryLambda(input: {shipmentID: "${getShipmnetHistoryInput.shipmentID}", ZipCode: "${getShipmnetHistoryInput.ZipCode}"}) {
            shipmentHistory {
              createdBy
              description
              imageURL
              latitude
              longitude
              notes
              processed
              processedDate
              shipmentStatusId
              shipmentid
              signatureId
            }
            deliveryPickup{
              address{
                companyName
                address1
                address2
                city
                state
                zipCode
              }
            }
            serviceAddress{
              address{
                companyName
                address1
                address2
                city
                state
                zipCode
              }
            },
            product{
              description
              additionalService
            }
          }
        }`
            
        try{
            let shipmentHistory = await API.graphql({
                query:  graphqlQuery,
                authMode: 'API_KEY'
            })
            
            let shipmentHistoryData = shipmentHistory.data.getShipmentHistoryLambda.shipmentHistory;
            console.log(shipmentHistoryData)
            this.LRexAPIDataHistory = shipmentHistoryData
            this.LRexAPIData = shipmentHistory.data.getShipmentHistoryLambda;
            this.showShipmentHistoryData = true;

            if(this.LRexAPIData.deliveryPickup){
              this.showShipmentData= true;
              this.toggleEnterZip = false;
            }
        }catch(e){
            console.log(e)
            this.loading = false;
            if(e){
                this.toggleAlertBox = true;
                this.alertMessage = e.errors[0].message || "Error getting shipment"
                console.log("Route Params: ", this.$route.params.shipZip)
                if(e.errors[0].message == "Unable to get shipment data."){
                  this.dataError = true;
                }else if(!this.$route.params.shipZip){
                  this.dataError = false;
                }else{
                  this.dataError = true;
                }
            }
        }finally{
            this.loading = false;
        }
      },
      GetDeliveryImages(imageURL, indexImageURL){
        this.showOverLay = true;
        this.indexImageURL = indexImageURL;
        this.linkImageURL = imageURL;
        this.loadingImage = true;
        setTimeout(() => {
          this.loadingImage = false;
        }, 1000);
      },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
        }
    },
    beforeMount(){
      Amplify.configure({
          ...awsconfig
      });
      this.TrackShipmentLRexAPI();
    }
}
</script>

<style scoped>
@import "../styles/button-styles.css";
.main-button-blue-white{
  padding-top: 5px;
  padding-bottom: 5px;
}

.main-button-green-black{
  font-size: 15px;
  padding: 12px;
}

.input-zip-container p{
  padding: 5px 10px;
  border-radius: 50px;
  margin-bottom: 10px !important;
  background-color: #fe804d !important;
  width: fit-content;
  font-weight: bold;
  margin-bottom: 15px;
  color: white;
}

.zip-form-input{
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.input-zip-inner{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  height: fit-content;
}

.input-zip-inner form{
  margin: 0;
}

.input-zip-inner input{
  padding: 10px;
  margin-left: 10px;
  font-size: 15px;
  border: 1px solid rgba(0, 0, 0, 0.336);
  border-radius: 5px;
  outline: none;
  margin-right: 10px;
}

.input-zip-container{
  margin-bottom: 10px;
}

/* Shipment Information */

.shipment-info-container{
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
}

.shipment-info-container-inner.remarks{
  border: 1px solid #b3b3b3;
  border-radius: 15px;
  width: fit-content
}

.shipment-info-container-inner.remarks p{
  margin-right: 10px;
}

.shipment-info-container-inner{
  width: 48%;
}

.shipment-info-container-inner p{
  margin-left: 10px;
}

.additional-information p, .shipment-information-inner p{
  margin-left: 0;
}

.inner-history-container{
  border: 1px solid #b3b3b3;
  border-radius: 15px;
  padding: 15px;
  margin: 15px;
  margin-left: 12.5%;
  width: 50%;
}

.history-container{
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.check-mark.active{
  background: linear-gradient(
    to bottom, 
    #ffffff 0%, 
    #ffffff 50%, 
    #33f18a 50%, 
    #33f18a 100%
  );
}

.check-mark.activeLast{
  background: linear-gradient(
    to top, 
    #ffffff 0%, 
    #ffffff 50%, 
    #33f18a 50%, 
    #33f18a 100%
  );
}

.proof-delivery-image {
    width: 100%; 
    height: 100%; 
    border: none; 
    display: block; 
    margin-bottom: 20px;
    border-radius: 25px;
}

.overlay-container{
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.7); /* Semi-transparent dark background */
  z-index: 999;
}

.overlay {
  position: fixed;
  top: 50%; 
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(255, 255, 255, 0.9);
  padding: 5px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 20%);
  z-index: 1000;
  text-align: center;
  height: 65vh;
  width: 90vw;
  border-radius: 25px;
}

.overlay button{
  position: fixed;
  top: -40px; 
  left: 5px;
  border: none;
  cursor: pointer;
  background-color: #32ccfe;
  color: #fff;
  padding: 10px 15px;
  border-radius: 99px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 20%);
  transition-duration: .25s;
  font-size: 12px;
}

.overlay button:hover{
  background-color: #2ebae9;
  transition-duration: .25s;
}

.overlay a{
  position: fixed;
  top: -40px; 
  left: 150px;
  border: none;
  cursor: pointer;
  background-color: #e0e0e0;
  color: #000;
  padding: 10px 15px;
  border-radius: 99px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 20%);
  transition-duration: .25s;
  text-decoration: none;
  font-size: 12px;
}

.overlay a:hover{
  background-color: #cfcfcf;
  transition-duration: .25s;
}

.proof-delivery-container{
  display: flex;
  flex-direction: column;
}

.proof-delivery-container button{
  margin-top: 5px;
  margin-bottom: 5px;
}

.check-mark{
  background-color:#33f18a;
  color: #fff;
  width: 2.5px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 4;
}

.check-mark-item{
  width: 30px;
  height: 30px;
  border-radius: 50px;
  background-color: #33f18a;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;
}

.check-mark-item img{
  width: 20px;
}

.check-mark-container{
  position: absolute;
  top: 0;
  bottom: 0;
  width: 10%;
  height: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
}

.history-description{
  font-weight: bold;
}

.history-process-date{
  background: #f0f0f0;
  color: #858585;
  border-radius: 2.5px;
  padding: 2px;
}

.history-description-container{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

p{
  margin-top: 0;
  margin-bottom: 0;
}

.down-arrow{
  border: solid #fff;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  margin-bottom: 3px;
  margin-left: 3px;
}

.up-arrow{
  border: solid #fff;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(-135deg);
  margin-top: 3px;
  margin-left: 3px;
}

.additional-information{
  background-color: #32ccfe;
  color: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: fit-content;
  margin-top: 5px;
  margin-bottom: 5px;
  padding: 4px;
  padding-right: 10px;
  padding-left: 10px;
  border-radius: 50px;
  cursor: pointer;
  transition-duration: .25s;
}

.additional-information:hover{
  background-color: #2db4e0;
  transition-duration: .25s;
}

.shipment-information{
  padding: 4px;
  padding-right: 10px;
  padding-left: 10px;
  border: 1px solid #b3b3b3;
  border-radius: 15px;
  width: fit-content;
  animation: animate-additional-info .35s ease;
}

th:first-child{
  border-top-left-radius: 15px;
}

th:last-child{
  border-top-right-radius: 15px;
}

@keyframes animate-additional-info {
  from{margin-top: -15px}
  to{margin-top: 0;}
}

.shipment-history-container{
  overflow-x: auto;
}
/* Delivery Image */
.delivery-image-container{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.delivery-image-container img{
  width: 40%;
  margin-top: 10px;
}

.show-delivery-image{
  cursor: pointer;
  color: #ffffff;
  background-color: #32ccfe;
  border: none;
  padding: 5px;
  border-radius: 15px;
  transition-duration: .5s ease;
}

.show-delivery-image:hover{
  background-color: #2bb1dd;
  transition-duration: .5s ease;
}

.container{
    width: 100%;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    text-align: left;
}

.shipment_data{
    width: 65%;
    box-shadow: 0 5px 15px rgb(0 0 0 / 20%);
    padding: 10px;
    border-radius: 25px;
}

.shipment_data h3{
  padding: 5px 10px;
  border-radius: 50px;
  background-color: #33f18a;
  border-bottom: 1px solid #33f18a;
  margin-top: 5px;
  margin-bottom: 5px;
}

.tracking-header{
  padding: 5px 10px;
  border-radius: 50px;
  background-color: #fe804d !important;
  border-bottom: 1px solid #fe804d !important;
  width: fit-content !important;
  color: white;
}

.shipment-table{
  width: 100%;
  margin-bottom: 15px;
}

.shipment-table th{
  background-color: #33f18a;
}

.shipment-table td, th{
  padding: 5px;
  border: 1px solid #ddd;
}

.logo{
  width: 175px;
  height: auto;
  margin-top: 5px !important;
}

.shipmentError{
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 5%;
}

.error-inner{
  width: fit-content;
  border-radius: 25px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 20%);
  padding: 15px;
}

.shipmentError img{
  width: 100px;
}


@media only screen and (max-width: 1000px){

    .shipment_data{
        width: 85%;
    }

    .inner-history-container{
      width: 70%;
    }

    .shipment-info-container{
      width: 95%;
    }
}

@media only screen and (max-width: 650px){

    .delivery-image-container img{
      width: 80%;
    }

    .shipment-info-container{
      flex-direction: column;
      width: 100%;
    }

    .shipment-info-container-inner{
      width: 100%;
    }

    .logo{
      width: 50%;
    }
}
</style>